import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const rejectQuotationThunk = createAsyncThunk(
    `RejectQuotationSlicer/rejectQuotationThunk`,
    async ({ solicitationId, note }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const config = { headers };

        const body = {
            note,
        };

        const { data } = await conciergeApiClient.post(
            `Redemption/${solicitationId}/reject-quotation`, body, config
        );

        return data;
    }
);

const initialState = {
    dataRejectQuotation: false,
    loadingRejectQuotation: false,
    errorRejectQuotation: false,
};

const RejectQuotationSlicer = createSlice({
    name: 'RejectQuotation',
    initialState,
    reducers: {
        resetDataRejectQuotation: (state) => {
            state.dataRejectQuotation = false;
            state.loadingRejectQuotation = false;
            state.errorRejectQuotation = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(rejectQuotationThunk.pending, (state) => {
            state.dataRejectQuotation = false;
            state.loadingRejectQuotation = true;
            state.errorRejectQuotation = false;
        });
        builder.addCase(rejectQuotationThunk.fulfilled, (state, action) => {
            state.dataRejectQuotation = true;
            state.loadingRejectQuotation = false;
            state.errorRejectQuotation = false;
        });
        builder.addCase(rejectQuotationThunk.rejected, (state) => {
            state.dataRejectQuotation = false;
            state.loadingRejectQuotation = false;
            state.errorRejectQuotation = true;
        });
    },
});

export const { resetDataRejectQuotation } = RejectQuotationSlicer.actions;
export default RejectQuotationSlicer.reducer;